import { zonoApi } from '../api/zonoApi';
import { updateCatalogPreference } from '../user-auth';
import {
  CatalogueView,
  ConfigDetailsRequest,
  ConfigDetailsResponse,
} from './config-model';
import { agentSettingsApi } from './agent-settings-api';
import {
  getHasFetchedAgentSettings,
  updateHasFetchedAgentSettings,
} from './config.slice';

export const configApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfigDetails: builder.mutation<
      ConfigDetailsResponse,
      ConfigDetailsRequest
    >({
      query(arg) {
        return {
          url: `configsettings/config`,
          params: { ...arg, random: Math.random() },
          method: 'GET',
        };
      },
      transformResponse: (response: ConfigDetailsResponse) => {
        const config = response.config;
        const transformedConfig = Object.fromEntries(
          Object.entries(config).map(([key, value]) => [
            key,
            value === 'true' ? true : value === 'false' ? false : value,
          ])
        );
        return { ...response, config: transformedConfig };
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled, getState }) {
        queryFulfilled
          .then((res) => {
            if (res.data.config.catalogueView === CatalogueView.ListView) {
              dispatch(updateCatalogPreference(undefined));
            }

            const sellerWorkspaceId = arg.workspaceId;
            const hasFetchedAgentSettings = getHasFetchedAgentSettings(
              getState() as any
            );

            if (sellerWorkspaceId && !hasFetchedAgentSettings) {
              dispatch(updateHasFetchedAgentSettings(true));
              dispatch(
                agentSettingsApi.endpoints.getAgentSettings.initiate({
                  sellerWorkspaceId,
                })
              );
            }
          })
          .catch((e) => console.log('getConfigDetails', e));
      },
    }),
  }),
});

export const { useGetConfigDetailsMutation } = configApi;
